import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Input, } from "components"
import InventoryRowSwitch from "./InventoryRowSwitch"
import InventoryRowCheckbox from "./InventoryRowCheckbox"
import InventoryRowApplyButton from "./InventoryRowApplyButton"
import classes from "./InventoryRowVariant.module.scss"

const InventoryRowVariant = props => {
  const { food, option, lastIndex } = props

  const [t, i18n] = useTranslation()

  const initialAvailableQuantityState =
    option.stockManagement
      ? option.availableQuantity
      : 0

  const inititalOutOfStockState =
    option.outOfStock

  const inititalStockManagementState =
    option.stockManagement

  const [loading, setLoading] = useState(false)
  const [sending, setSending] = useState(false)
  const [stockIn, setStockIn] = useState("")
  const [stockOut, setStockOut] = useState("")
  const [outOfStock, setOutOfStock] = useState(inititalOutOfStockState)
  const [stockManagement, setStockManagement] = useState(inititalStockManagementState)
  const [availableQuantity, setAvailableQuantity] = useState(initialAvailableQuantityState)

  const disabled = !stockManagement

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <tr className={clsx(lastIndex && classes["border-bottom"])}>
      <td className={clsx(classes["cell"], classes["code"])} />

      <td className={clsx(classes["cell"], classes["name"])}>
        {option.name}
      </td>

      <td className={classes["cell"]}>
        <div className={classes["stockManagement"]}>
          <InventoryRowCheckbox
            food={food}
            option={option}
            stockManagement={stockManagement}
            setStockManagement={setStockManagement}
            availableQuantity={availableQuantity}
            setOutOfStock={setOutOfStock}
          />

          <Input
            min={0}
            type="number"
            placeholder={t("ورودی")}
            value={stockIn}
            disabled={disabled}
            numberType={food.unit === "quantity" ? "int" : "float"}
            className={clsx(
              classes["input"],
              isLtr && classes["input-ltr"],
              disabled && classes["disabled"]
            )}
            onChange={(e) => {
              setStockOut("")
              setStockIn(e.target.value)
            }}
          />

          <Input
            min={0}
            type="number"
            placeholder={t("خروجی")}
            className={clsx(classes["input"], disabled && classes["disabled"])}
            value={stockOut}
            disabled={disabled}
            numberType={food.unit === "quantity" ? "int" : "float"}
            onChange={(e) => {
              setStockIn("")
              setStockOut(e.target.value)
            }}
          />

          <InventoryRowApplyButton
            food={food}
            option={option}
            sending={sending}
            setSending={setSending}
            setOutOfStock={setOutOfStock}
            stockIn={stockIn}
            setStockIn={setStockIn}
            stockOut={stockOut}
            setStockOut={setStockOut}
            stockManagement={stockManagement}
            availableQuantity={availableQuantity}
            setAvailableQuantity={setAvailableQuantity}
          />
        </div>
      </td >

      <td className={clsx(classes["cell"], classes["outOfStock"])}>
        <InventoryRowSwitch
          food={food}
          option={option}
          loading={loading}
          setStockIn={setStockIn}
          setStockOut={setStockOut}
          setLoading={setLoading}
          outOfStock={outOfStock}
          setOutOfStock={setOutOfStock}
          setAvailableQuantity={setAvailableQuantity}
        />
      </td>

      <td className={clsx(classes.cell, classes.inventory)}>
        {option.stockManagement ? availableQuantity : "-"}
      </td>
    </tr >
  )
}

export default InventoryRowVariant